// components/EstadosManager.js
import React, { useState, useEffect } from 'react';
import {
  Button, Input
} from 'reactstrap';
import {
  PlusCircle, Trash2, Flag
} from 'lucide-react';
import {
  getStates, saveStates, deleteState
} from '../../../helpers/backend';
import './styles/Typifications.css';

const EstadosManager = () => {
  const [estados, setEstados] = useState([]);
  const [newEstado, setNewEstado] = useState({ name: '', description: '' });
  const [isSaving, setIsSaving] = useState(false);

  const loadEstados = async () => {
    try {
      const res = await getStates();
      setEstados(res.data.results || []);
    } catch {
      alert('Error cargando estados');
    }
  };

  useEffect(() => {
    loadEstados();
  }, []);

  const handleCreate = async () => {
    if (!newEstado.name.trim()) return;
    try {
      setIsSaving(true);
      await saveStates(newEstado);
      setNewEstado({ name: '', description: '' });
      loadEstados();
    } catch {
      alert('Error creando estado');
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar este estado?')) return;
    try {
      await deleteState(id);
      loadEstados();
    } catch {
      alert('Error eliminando estado');
    }
  };

  return (
    <div>
      <h5 className="section-title mb-3">Estados</h5>

      <div className="new-estado-row mb-3">
        <Input
          placeholder="Nombre del estado"
          value={newEstado.name}
          onChange={(e) => setNewEstado({ ...newEstado, name: e.target.value })}
        />
        <Input
          placeholder="Descripción"
          value={newEstado.description}
          onChange={(e) => setNewEstado({ ...newEstado, description: e.target.value })}
        />
        <Button color="primary" onClick={handleCreate} disabled={isSaving}>
          <PlusCircle size={16} className="me-1" />
          Crear
        </Button>
      </div>

      <div className="estado-list">
        {estados.map((e) => (
          <div key={e.id} className="estado-card">
            <div className="estado-info">
              <div className="estado-nombre">
                <Flag size={14} className="me-2 text-muted" />
                <strong>{e.name}</strong>
              </div>
              <div className="text-muted small">{e.description || 'Sin descripción'}</div>
            </div>
            <Button size="sm" color="danger" onClick={() => handleDelete(e.id)}>
              <Trash2 size={14} />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EstadosManager;
